import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import Modal from 'src/components/Modal'
import { selectInventoryDetails } from '../../InventorySelector'
import { actions } from '../../InventoryState'
import * as S from './ModalIncrement.styles'

export default ({
  open, setOpen, id,
}) => {
  const dispatch = useDispatch()
  const inventoryDetail = useSelector(selectInventoryDetails)
  const [productsCodeNotFound, setProductsCodeNotFound] = useState<string[]>([])
  const [products, setProducts] = useState([])

  const {
    register, setError, reset, formState: { errors },
  } = useForm()
  const [inputValue, setInputValue] = useState('')
  const handleInputChange = (event) => {
    const { value } = event.target

    const formattedValue = value
      .split('\n')
      .map((line) => {
        const parts = line.split(/\s+/).map((part) => part.trim())
        if (parts.length === 2) {
          const [productCode, quantity] = parts
          const formattedProductCode = productCode.padEnd(20, ' ')
          return `${formattedProductCode} ${quantity}`
        }
        return line.trim()
      })
      .join('\n')

    const formattedData = value
      .split('\n')
      .map((line) => {
        const parts = line.split(/\s+/).map((part) => part.trim())
        if (parts.length === 2) {
          const [productCode, quantity] = parts
          return { productCode, quantity }
        }
        return null
      })
      .filter((item) => item !== null)

    setInputValue(formattedValue)
    setProducts(formattedData)
  }

  const onSubmit = () => {
    if (!inputValue) {
      setError('incrementStock', { message: 'Campo obrigatório' })
      return
    }

    dispatch(actions.incrementDecrementInventory({
      id, products, setProductsCodeNotFound, setOpen, setInputValue,
    }))
  }

  const onClickCancel = () => {
    setInputValue('')
    setProductsCodeNotFound([])
    reset()
    setOpen(false)
  }

  return (
    <Modal
      title='Incremento/Decremento de estoque'
      show={open}
      closedButton={false}
      size='lg'
      body={(
        <>
          <S.ContainerTextArea>
            <S.CustomTextArea
              inputProps={{
                ...register('incrementStock', { required: 'Campo obrigatório' }),
                'data-testid': 'increment-stock-test',
              }}
              value={inputValue}
              id='incrementStock'
              name='incrementStock'
              error={!!errors.incrementStock}
              label='Cole aqui os ajustes relacionados a pedidos a desfazer'
              helperText={errors.incrementStock?.message}
              type='text'
              autoComplete='off'
              onChange={handleInputChange}
              fullWidth
              multiline
              rows={10}
            />
            <p>*Os valores aqui colados serão adicionados ou subtraidos do valor total do estoque fiscal</p>
            {productsCodeNotFound.length > 0 && (<><span>Produtos não encontrados: </span>{productsCodeNotFound?.join(', ')}</>)}
          </S.ContainerTextArea>
          <S.ContainerButton>
            <S.CustomButton
              title='Cancelar'
              bgColor='lightRed'
              hoverColor='cancelHover'
              letterColor='white'
              onClick={() => onClickCancel()}
            />
            <S.CustomButton
              title='Confirmar'
              type='submit'
              bgColor='confirm'
              hoverColor='confirmHover'
              letterColor='white'
              onClick={() => onSubmit()}
              data-testid='confirm-button-test'
              disabled={inventoryDetail.inventoryStatus === 'Cancelado' || inventoryDetail.inventoryStatus === 'Finalizado'}
            />
          </S.ContainerButton>
        </>
      )}
    />
  )
}
